import {
	PoolCard,
	PoolDescription,
	PoolInfoLabel,
	PoolInfoRow,
	PoolInfoValue,
	PoolName,
	PoolsContainer,
} from './PoolsSection.styles';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { Divider } from 'features/common/components/Divider';
import { FC } from 'react';
import { IdParamsType } from 'utils/types';
import { ROUTES } from 'features/routes';
import { SectionTitle } from 'features/common/components/SectionTitle';
import { getData } from 'services/api';
import { useAppSelector } from 'store/hooks';
import { useQuery } from '@tanstack/react-query';
import { useResponsiveScreen } from 'hooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import { Pool } from 'features/PunchupTicketDetails/types';
import { camelize } from 'utils/utils';

const PoolsSection: FC = () => {
	const { t } = useTranslation();
	const { id }: IdParamsType = useParams();
	const isLargeScreen = useResponsiveScreen();
	const { push } = useHistory();
	const { isPunchup } = useAppSelector((state) => state.auth);

	const { data: pools = [] } = useQuery<Pool[]>({
		queryKey: ['eventPools', id],
		queryFn: () => getData(`/events/${id}/pools`),
		initialData: [],
		select: (data) => camelize(data) as Pool[],
	});

	const onClickAddNew = () => {
		if (isPunchup) {
			window.parent.postMessage({ action: 'event-create-pool-clicked', eventId: id }, '*');
		}
		push(generatePath(ROUTES.POOLS_NEW_PATH, { id }));
	};

	return (
		<>
			<SectionTitle title={t('dashboard-pools')} buttonLabel={t('dashboard-add')} onClick={onClickAddNew} />
			<PoolsContainer>
				{pools.length ? (
					pools.map((pool) => (
						<PoolCard
							key={pool.ID}
							onMouseOver={(e) => (e.currentTarget.style.boxShadow = '0 4px 16px rgba(254,94,37,0.18)')}
							onMouseOut={(e) => (e.currentTarget.style.boxShadow = '0 2px 8px rgba(254,94,37,0.08)')}
							onClick={() => push(generatePath(ROUTES.POOLS_EDIT_PATH, { id, poolId: pool.ID.toString() }))}
						>
							<PoolName>{pool.name}</PoolName>
							{pool.description && <PoolDescription>{pool.description}</PoolDescription>}
							<PoolInfoRow>
								<PoolInfoLabel>{t('Availability')}:</PoolInfoLabel> {pool.sold ?? 0} / {pool.totalAmount ?? 0}
							</PoolInfoRow>
							<PoolInfoRow>
								<PoolInfoLabel>{t('Tickets')}:</PoolInfoLabel>
								<PoolInfoValue>
									{pool.ticketTypes && pool.ticketTypes.length > 0
										? pool.ticketTypes.map((tt) => tt.name).join(', ')
										: t('No tickets')}
								</PoolInfoValue>
							</PoolInfoRow>
						</PoolCard>
					))
				) : (
					<div style={{ padding: 24, color: '#888', width: '100%', textAlign: 'center' }}>This event has no pools</div>
				)}
			</PoolsContainer>
			{!isLargeScreen && <Divider />}
		</>
	);
};

export { PoolsSection };
